import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'muni-gameday-params-cell',
  template: `
        <div class="recent-orders-left-cell-container">
            <muni-gameday-profile-overview-open-link
                [text]='params.data?.account'
                [linkType]="params.data?.linkType"
                [cropped]="false"
            >
            </muni-gameday-profile-overview-open-link>
            <div class="manager">{{ params.data?.manager }}</div>
        </div>
        `,
  styleUrls: ['./recent-orders.styles.scss']
})
export class RecentOrdersLeftCellRendererComponent
  implements ICellRendererAngularComp {
  public params: ICellRendererParams;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }
}
